// Back to Top Button
const offset = 250;

$(window).on('scroll', function () {
    if ($(this).scrollTop() > offset) {
        $('.back-to-top-btn').fadeIn();
    } else {
        $('.back-to-top-btn').fadeOut();
    }
});

$('.back-to-top-btn').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 500);
    return false;
});
